;
var sprite = require("/tmp/build_28b142ae/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Next_5cb711d7b5a86e119f8410684b645d5f\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M40.522,83.812l-3.017-3.016l30.749-30.748L37.408,19.203l3.017-3.016l33.861,33.862L40.522,83.812z\"/> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Next_5cb711d7b5a86e119f8410684b645d5f");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Next.svg
// module id = 590
// module chunks = 0